import React from 'react';

const WindowWrapper = ({ children, style, maxWidth, maxHeight, close, ...props }) => {
  return (
    <>
      <div
        {...props}
        style={{
          width: window.innerWidth <= 500 ? '95%' : '80%',
          maxWidth,
          maxHeight: window.innerWidth <= 500 ? window.innerHeight - 100 : maxHeight,
          top: window.innerWidth <= 500 ? 40 : window.innerHeight / 2 - (maxHeight / 2),
          left: window.innerWidth <= 500 ? '2.5%' : window.innerWidth / 2 - (maxWidth / 2),
          overflowY: 'scroll',
          overflowX: 'hidden',
          ...style
        }}
        className={props.className + ' window'}
      >
        <div style={{ height: 50 }} />
        {children}
      </div>
      <p
        style={{
          cursor: 'pointer',
          color: 'black',
          textAlign: 'center',
          width: 30,
          height: 30,
          fontSize: 20,
          borderRadius: '50%',
          background: 'white',
          position: 'fixed',
          top: window.innerWidth <= 500 ? 5 : window.innerHeight / 2 - (maxHeight / 2) - 35,
          right: window.innerWidth <= 500 ? '2.5%' : window.innerWidth / 2 - (maxWidth / 2),
          zIndex: style.zIndex
        }}
        onClick={() => close()}
      >
        <i className='fa fa-close' />
      </p>
    </>
  );
};

export default WindowWrapper;
